import { CbhIcon, Title } from "@clipboard-health/ui-components";
import { DialogContent, Stack, TextField } from "@mui/material";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { useFormContext } from "react-hook-form";

import { type PostShiftReviewFormValues, type StepAction } from "../types";

export interface ParkingQuestionStepProps {
  isSubmitting?: boolean;
  onAction: (action: StepAction) => void;
}

export function ParkingQuestionStep({ isSubmitting = false, onAction }: ParkingQuestionStepProps) {
  const { watch, setValue } = useFormContext<PostShiftReviewFormValues>();
  const parkingText = watch("parkingAnswer") ?? "";

  return (
    <>
      <DialogContent sx={{ py: 2 }}>
        <Stack spacing={6} sx={{ px: 0 }}>
          <Stack alignItems="center" spacing={4}>
            <CbhIcon type="car" size="large" />
            <Title variant="h3" component="h3" textAlign="center">
              Where did you park?
            </Title>
          </Stack>

          <TextField
            multiline
            placeholder="Describe a general location to help other new workers know where to park"
            value={parkingText}
            disabled={isSubmitting}
            rows={4}
            sx={{ pt: 5 }}
            onChange={(event) => {
              setValue("parkingAnswer", event.target.value, { shouldValidate: true });
            }}
          />
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Stack spacing={3} sx={{ px: 0, width: "100%" }}>
          <LoadingButton
            fullWidth
            size="large"
            variant="contained"
            isLoading={isSubmitting}
            onClick={() => {
              onAction({
                type: "NEXT_STEP",
                data: { parkingAnswer: parkingText.trim() || undefined },
              });
            }}
          >
            Continue
          </LoadingButton>

          {!isSubmitting && (
            <LoadingButton
              fullWidth
              size="large"
              variant="text"
              isLoading={false}
              onClick={() => {
                onAction({
                  type: "NEXT_STEP",
                  data: { parkingAnswer: undefined },
                });
              }}
            >
              I didn&apos;t park
            </LoadingButton>
          )}
        </Stack>
      </DialogFooter>
    </>
  );
}
